var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://docs.google.com/document/d/1UEDlhzGMAPytChWKkGPB1H7CsrxNQZJrxSFIswSiJRA/edit?usp=drive_link","target":"_blank","rel":"noopener"}},[_vm._v("FCX user guide")])}
var staticRenderFns = []

export { render, staticRenderFns }